import { Button, Size } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface ILandingFooterProps {
   
}
const LandingFooter = (props: ILandingFooterProps): JSX.Element => {
    const { currentLanding } = useLandingStore((state: ILandingStore) => state) 
    const onEditLanding = () => {
        useLandingStore.setState({ isSectionEdit: true, sectionEditTab: "main", schema: "Landing", currentEditData: { ...currentLanding } })
    }
    return <div className='pe-landing-footer-container flex-centered'>
        <Button variant="minimal" onClick={onEditLanding}>
            {__("Landing settings")}
        </Button>
    </div>
}
export default LandingFooter
